import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const defaultProps = {
  url: "",
  onLoadComplete: () => {},
};

const propTypes = {
  url: PropTypes.string,
  onLoadComplete: PropTypes.func,
};

const WithIframe = (props) => {
  let { url, onLoadComplete } = props;
  const containerRef = useRef(null);

  const [width, setWidth] = React.useState(window.innerWidth);
  const [height, setHeight] = React.useState(300);

  const updateWidthAndHeight = () => {
    setWidth(window.innerWidth);
    // Get the total clientHeight of the parentElement
    const {
      parentElement: { clientHeight },
    } = containerRef.current;
    // Set the total desired height of the iframe from the calculation
    setHeight(clientHeight);
  };

  useEffect(() => {
    updateWidthAndHeight();
    window.addEventListener("resize", updateWidthAndHeight);

    return () => window.removeEventListener("resize", updateWidthAndHeight);
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="with-iframe"
      style={{ height: '765px' }}
    >
      {url ? (
        <iframe
          src={url}
          width={width}
          height={height}
          title={url}
          style={{ border: "none" }}
          onLoad={onLoadComplete}
        />
      ) : null}
    </div>
  );
};

WithIframe.defaultProps = defaultProps;
WithIframe.propTypes = propTypes;

export default WithIframe;
